module.exports = __webpack_public_path__ + "fed134441061330e6602bf06acda8ecd.svg";